import { formatLocale } from './formatLocale';
/**
 * Gets the current Weglot locale from localStorage or Weglot API
 * Priority: localStorage 'wglang' > Weglot.getCurrentLang() > null
 * @returns The current locale string formatted properly (e.g., 'es-MX') or null if unavailable
 */
export const getCurrentWeglotLocale = () => {
    try {
        // First check localStorage
        const storedLocale = localStorage.getItem('wglang');
        if (storedLocale) {
            return formatLocale(storedLocale);
        }
        // Fallback to Weglot API if available
        if (window.Weglot?.getCurrentLang) {
            const currentLang = window.Weglot.getCurrentLang();
            return currentLang ? formatLocale(currentLang) : null;
        }
        return null;
    }
    catch (error) {
        console.warn('Failed to get Weglot locale:', error);
        return null;
    }
};
